<template>
  <div class="loader">
      <img src="../../assets/images/loader.gif" />
  </div>
</template> 
<script>
export default {
  name: "Loader" 
}
</script>